import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
// import Home from "../views/Home.vue";
import FrontPage from "../views/FrontPage.vue";
import ArchiveList from "../views/ArchiveList.vue";
import store from "@/store/index";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Frontpage",
    component: FrontPage,
  },
  {
    path: "/list",
    name: "List",
    component: ArchiveList,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  let tempPassword: string | null = "";

  if (store.getters.loginPassword) {
    tempPassword = store.getters.loginPassword;
  } else {
    if (sessionStorage.getItem("loginPassword")) {
      tempPassword = sessionStorage.getItem("loginPassword");
    }
  }

  if (to.name == "Frontpage") {
    if (tempPassword) {
      next("/list");
    } else {
      next();
    }
  } else {
    if (!tempPassword) {
      next("/");
    } else {
      next();
    }
  }
});

export default router;
